import { useLocation } from "react-router-dom";
import PaginationBtns from "../components/inputs/pagination-btns";
import TabbedMenu from "../components/inputs/tabbed-menu";
import LoadingIndicator from "../components/loaders/loading-indicator";
import { FC, useEffect, useState } from "react";
import PageError from "../components/errors/page-error";
import { RPI_TABS } from "../models";
import { useGetAllBookOrdersQuery } from "../store/base-api";
import RpiRequestListItem from "../components/list-items/rpi-request-list-items";

export default function RPIRequests() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const currentPage = Number(params.get("currentPage") || 1);

  const current = params.get("currentTab") || RPI_TABS[0].key;
  const currentTab = Number(
    RPI_TABS.find(({ key }) => key === current)?.value || 0,
  );

  const [loading, setLoading] = useState(true);

  const { data, isFetching, isLoading, error } = useGetAllBookOrdersQuery({
    currentTab,
    currentPage,
  });

  useEffect(() => {
    setLoading(isFetching || isLoading);
  }, [isLoading, isFetching]);

  return (
    <div className="flex flex-col relative flex-1 w-full overflow-y-auto max-h-[calc(100vh-96px)]">
      <div className="sticky z-10 flex flex-wrap px-8 py-2 gap-x-4 gap-y-2 items-center justify-between top-0 bg-white shadow-md">
        <TabbedMenu tabs={RPI_TABS} />
        <PaginationBtns totalPages={data?.totalPages || 0} />
      </div>

      {error ? (
        <PageError error={error} />
      ) : (
        <div className="flex flex-col p-4 flex-1">
          <div className="flex flex-col flex-1 gap-2">
            {loading || !data ? (
              <div className="flex-1 grid place-items-center">
                <LoadingIndicator />
              </div>
            ) : !data.totalItems ? (
              <EmptyListView currentTab={current} />
            ) : (
              data.items.map((req) => (
                <RpiRequestListItem key={req.id} {...req} />
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const EmptyListView: FC<{ currentTab: string }> = ({ currentTab }) => {
  return (
    <div className="grid flex-1 place-items-center">
      <p>There are currently no {currentTab} book orders.</p>
    </div>
  );
};
